<template>
    <div>
            <!--头部-->
            <div class="mrb20">
                <el-button class="mrl20" type="primary"  :class="baseerp+'btn'" @click="addData">添加</el-button>
            </div>
            <!--列表-->
            <div>
                <el-table
                        class="mrt10"
                        size="mini"
                        :data="tableData"
                        height="660"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        :highlight-current-row="highlightCurrentRow">
                    <el-table-column
                            prop="i_id"
                            label="ID"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_no"
                            :label="$t('form_serial_number')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="f_num"
                            label="申请数量">
                    </el-table-column>
                    <el-table-column
                            prop="f_innum"
                            label="已入库"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_ingsname"
                            :label="$t('form_company')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_inckname"
                            :label="$t('form_warehouse')"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="dt_createtime"
                            label="申请日期"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_lruname"
                            label="收货人"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_state"
                            label="是否已收货"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="50">
                        <template slot-scope="scope">
                            <el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--添加/编辑dialog-->
            <div :class="baseerp+'div'">
                <el-dialog
                         width="1000px"
                        :title="title"
                        :visible.sync="DialogVisible"
                        :close-on-click-modal="false"
                        @close="cancelDialog"
                        v-if="DialogVisible">
                    <receive-form :receive="receive" @close="cancelDialog"></receive-form>
                </el-dialog>
            </div>
            <!--分页-->
            <div>
                <el-pagination
                        class="fr page"
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="currentPage"
                        :total="tableTotal"
                        :page-size="pageSize">
                </el-pagination>
            </div>
    </div>
</template>

<script>
    //import * as API from "./api"
    import ReceiveForm from "./ReceiveForm";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "ReceivingList",
        components: {ReceiveForm},
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                receive:{},
                baseerp:"",
                pageSize:13,
                currentPage:1,
                tableTotal:0,
                tableData:[
                    {i_id:1}
                ],
                highlightCurrentRow:true,
                title:'',
                DialogVisible:false,
                processDa:"",
                processId:'',
            }
        },

        watch:{
            formvalue:{
                handler(){
                    // console.log(this.formvalue,"从ProcessList窜过来");
                    if (this.formvalue){
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.processDa = this.formvalue.value;
                                this.processId = this.formvalue.i_id;
                                //调接口
                                //console.log(this.taskDa,this.taskId,"this.task");
                            }
                        }
                    }
                },
                immediate:true,
                deep:true
            },
        },

        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            //点击添加
            addData(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.DialogVisible=false;
                    this.$message.error("请选择要的添加左侧加工公司！")
                }else{
                    this.title="添加收货单";
                    this.highlightCurrentRow=true;
                    this.receive={
                        title:"添加收货单",
                        processDa:this.processDa,
                        processId:this.processId,
                        value:"",
                        i_id:0,
                        page_size:1,
                    };
                    // console.log(this.receive,"添加receive");
                    this.DialogVisible=true;
                }
            },

            //编辑
            edit(row){
                // console.log(row,"row");
                this.title="编辑入库申请";
                this.receive={
                    title:"编辑收货单",
                    processDa:this.processDa,
                    processId:this.processId,
                    i_id:row.i_id,
                    value:row,
                    page_size:this.currentPage,
                };
                // console.log(this.receive,"编辑receive");
                this.DialogVisible=true;
            },

            cancelDialog() {
                this.DialogVisible = false;
                this.highlightCurrentRow = true;
            },

            //分页
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口

            }
        },
    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 10px;
    }

</style>